"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.saveUserSetting = exports.bulkGetUserSettings = exports.fetchUserSetting = void 0;

var _reduxObservable = require("redux-observable");

var _of = require("rxjs/observable/of");

var _fromPromise = require("rxjs/observable/fromPromise");

var _filter = require("rxjs/operators/filter");

var _mergeMap = require("rxjs/operators/mergeMap");

var _map = require("rxjs/operators/map");

var _catchError = require("rxjs/operators/catchError");

var _startWith = require("rxjs/operators/startWith");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _API = _interopRequireDefault(require("settings-ui-sdk/UserSettings/API"));

var _actions = require("settings-ui-sdk/UserSettings/actions");

var _selectors = require("settings-ui-sdk/UserSettings/selectors");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var fetchUserSetting = function fetchUserSetting($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions.UserSettingsActionTypes.FETCH_USER_SETTING).pipe((0, _filter.filter)(function (action) {
    var _action$payload = action.payload,
        namespace = _action$payload.namespace,
        key = _action$payload.key,
        value = _action$payload.value;
    return (0, _selectors.getFetchUserSettingsRequestStatus)(namespace, key, value)(getState()) === _RequestStatusTypes.default.UNINITIALIZED;
  }), (0, _mergeMap.mergeMap)(function (action) {
    return (0, _fromPromise.fromPromise)(_API.default.getUserSetting(action.payload)).pipe((0, _map.map)(function (response) {
      return _actions.FetchUserSetting.success(response, action.payload);
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(_actions.FetchUserSetting.failure(error, action.payload));
    }), (0, _startWith.startWith)(_actions.FetchUserSetting.request(action.payload)));
  }));
};

exports.fetchUserSetting = fetchUserSetting;
var bulkGetUserSettings = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.bulkGetUserSettings,
  initiatingActionType: _actions.UserSettingsActionTypes.BULK_GET_USER_SETTINGS,
  requestActions: _actions.BulkGetUserSettings,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.UserSettingsActionTypes.BULK_GET_USER_SETTINGS)
}));
exports.bulkGetUserSettings = bulkGetUserSettings;
var saveUserSetting = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.saveUserSetting,
  initiatingActionType: _actions.UserSettingsActionTypes.SAVE_USER_SETTING,
  requestActions: _actions.SaveUserSetting,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.PENDING, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.UserSettingsActionTypes.SAVE_USER_SETTING)
}));
exports.saveUserSetting = saveUserSetting;

var _default = (0, _reduxObservable.combineEpics)(fetchUserSetting, bulkGetUserSettings, saveUserSetting);

exports.default = _default;